// extracted by mini-css-extract-plugin
export default {"img_icon":"styles_img_icon__ik76P"};